import styled from 'styled-components';

export const ModalText = styled.div`
  max-width: 270px;
  margin: auto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: center;
  color: ${({ theme }) => theme.colors.main};
  padding: 12px 24px 0;
  & span {
    display: block;
    font-size: 16px;
    font-weight: 700;
    margin: 17px 0;
  }
  svg {
    margin: 0 auto 20px;
    display: block;
  }
`;

export const ButtonFooter = styled.div`
  width: fit-content;
  margin: 30px auto 0;
  display: flex;
  gap: 13px;
`;
